import type { ClientPortfolioManualValueResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { mapManualValueToForm } from "web_myplann/Portfolio/PortfolioShared/ManualValue/mapManualValueToForm";
import { sortManualValuesNewestFirst } from "web_myplann/Portfolio/PortfolioShared/ManualValue/sortManualValuesNewestFirst";
import type { ToolPreviousValue } from "web_myplann/Portfolio/PortfolioShared/ManualValue/toolPreviousValueSchema";

export const mapToolManualValuesToForm = (
	manualValues: ClientPortfolioManualValueResponseDTO[],
) => {
	const [latest, ...previous] = sortManualValuesNewestFirst(manualValues);

	return {
		...mapManualValueToForm(latest),
		valueId: latest?.id ?? null,
		previousValues: previous.map(
			({ id, value, invested, date }): ToolPreviousValue => ({
				id,
				value,
				invested: invested ?? null,
				date,
			}),
		),
	};
};
